
'use client';

import { LoginForm } from '@/components/auth/login-form';
import { useUser as useFirebaseUser } from '@/firebase/provider';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';

export default function LoginPage() {
  const { user: firebaseUser } = useFirebaseUser();
  const router = useRouter();
  const [isRedirecting, setIsRedirecting] = useState(false);

  useEffect(() => {
    if (firebaseUser) {
      setIsRedirecting(true);
      // Add a small delay to prevent white screen flash
      const timer = setTimeout(() => {
        router.replace('/dashboard');
      }, 100);
      
      return () => clearTimeout(timer);
    }
  }, [firebaseUser, router]);

  if (firebaseUser) {
    return (
       <div className="flex min-h-screen flex-col items-center justify-center bg-background p-4">
          <div className="flex flex-col items-center space-y-4">
            <Loader2 className="h-8 w-8 animate-spin text-primary" />
            <p className="text-sm text-muted-foreground">
              {isRedirecting ? 'Redirecting to dashboard...' : 'Authenticating...'}
            </p>
          </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background p-4">
        <LoginForm />
    </div>
  );
}
